import ButtonUpload from '@/components/button-upload'
// import {prefixPath} from '@/config'
export default function () {
  let that = this
  return [
    {
      'title': '姓名',
      [$field]: 'userName'
    },
    {
      'title': '性别',
      width: 50,
      [$field]: 'gender',
      render: (h, params) => {
        return h('div', [
          h('span', that.dictMap['DM14'][params.row.gender])
        ])
      }
    },
    {
      'title': '工号',
      [$field]: 'userCode'
    },
    {
      'title': '政治面貌',
      [$field]: 'political',
      render: (h, params) => {
        return h('div', [
          h('span', that.dictMap['GB4762'][params.row.political])
        ])
      }
    },
    {
      'title': '工作地',
      [$field]: 'bWorkplace'
    },
    {
      'title': '发薪地',
      [$field]: 'payrollPlace'
    },
    {
      'title': '联系电话',
      width: 110,
      [$field]: 'phone'
    },
    {
      'title': '管理职务',
      [$field]: 'dutyName'
    },
    {
      'title': '岗位信息详情',
      width: 150,
      [$field]: 'stdPosition'
    },
    {
      'title': '所属党组织',
      [$field]: 'orgName'
    },
    {
      'title': '是否签署',
      [$field]: 'qianshu',
      width: 80,
      render: (h, params) => {
        let qianshu = that.isSign
        return h('div', [
          h('span', {
            style: {
              color: qianshu == 'yes' ? 'green' :  (qianshu == 'again' ? 'orange' : '#FA2900')
            }
          }, qianshu == 'yes' ? '已签署' : (qianshu == 'again' ? '重新签署' : '未签署'))
        ])
      }
    },
    {
      'title': '签署模板文件',
      width: 110,
      [$field]: 'wenjian',
      render: (h, {row}) => {
        return h('div', [
          h('span', {
            style: {
              'text-decoration': 'underline'
            },
            class: 'iv-pointer iv-hover-color',
            on: {
              'click': function () {
                that.getFilePath()
              }
            }
          }, '下载签署模板')
        ])
      }
    },
    {
      'title': '操作',
      [$field]: 'wenjian',
      render: (h, {row}) => {
        if (this.isSign == 'no') {
          return h('div', [
            h(ButtonUpload, {
              props: {
                label: row.fileId ? row.fileName : '上传签字文件',
                isText: true,
                url: 'api-uum/file/upload',
                accept: '.xlsx,.xls,.excel,.pdf,.doc,.docx'
              },
              style: {
                'padding': '0',
                'line-height': '20px',
                'margin-top': '8px',
                'display': 'inline-block'
              },
              class: ['iv-main-color', 'iv-hover-color'],
              on: {
                'on-upload-success': (file) => {
                  this.$set(this.tableData[row._index], 'fileName', file.response.data.fileName)
                  this.$set(this.tableData[row._index], 'fileId', file.response.data.fileId)
                  this.$Message.success('上传成功')
                  this.fileSubmit(file.response.data.fileId)
                }
              }
            })
          ])
        } else {
          return h('div', [
            h('span', {
              style: {
                'text-decoration': 'underline'
              },
              class: 'iv-pointer iv-hover-color',
              on: {
                'click': function () {
                  that.fileDown('see')
                }
              }
            }, '查看签署文件')
          ])
        }
      }
    }
  ]
}